import Vue from "vue";

import GamesForPrizesDetail from "./GamesForPrizesDetail.vue";

export function load() {
    const selector = "games-for-prizes-detail";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(GamesForPrizesDetail, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
